import { RateCardType } from '@types';

/**
 * Whether a rate card, on a Lane or on settings, is the given one: an Item rate card by its Item
 * type, any other by its type. A rate card with an Item type is only ever matched by it.
 */
export const matchesRateCard = (
	rateCard: { type: RateCardType; item_type_id?: string },
	type: RateCardType | null,
	itemTypeId?: string | null
) => {
	if (itemTypeId) return rateCard.item_type_id === itemTypeId;
	return rateCard.type === type && !rateCard.item_type_id;
}
